<template>
  <v-text-field
    type="text"
    :append-icon="showInfo ? 'visibility' : 'visibility_off'"
    class="default-input"
    :class="showInfo ? '' : 'sensitive-input'"
    solo
    v-model="fieldText"
    :rules="
      question.number_of_characters
        ? [rules.chars(question.number_of_characters)]
        : []
    "
    :counter="!!question.number_of_characters"
    :maxlength="question.number_of_characters"
    @change="$emit('change')"
    @click:append="showInfo = !showInfo"
  />
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import 'text-security/text-security.css';

export default {
  name: 'SensitiveTypeInput',
  props: {
    value: {
      type: String,
    },
    question: {
      type: Object,
    },
  },
  watch: {
    fieldText() {
      this.$emit('input', this.fieldText);
    },
    value() {
      this.fieldText = this.value;
    },
  },
  methods: {
    isEmpty,
  },
  data() {
    return {
      showInfo: false,
      fieldText: null,
      rules: {
        chars(maxNum) {
          const maxIntNum = parseInt(maxNum);
          return v =>
            (v || '').length === maxIntNum ||
            `Must contain ${maxNum} characters`;
        },
      },
    };
  },
  created() {
    if (this.value) {
      this.fieldText = this.value;
    }
  },
};
</script>

<style scoped>
.sensitive-input {
  font-family: text-security-disc;
}
</style>
